function initSliders() {
    $('.slider').slick({
        dots: true,
        prevArrow: '<a href="#" class="slider__prev"></a>',
        nextArrow: '<a href="#" class="slider__next"></a>',
        appendDots: $('.slider__dots')
    });
}